import React from 'react';
import { LinkedInCallback as LinkedInCallbackLib } from 'react-linkedin-login-oauth2';

const LinkedInCallback = () => {
  return <LinkedInCallbackLib />;
};

export default LinkedInCallback;
